import Colors from 'assets/Colors';
import Logger from 'common/helpers/Logger';
import Configs from 'utils/Configs';
import ThemeProvider from '../providers/ThemeProvider';

export default {
  changeTheme: (darkMode = false) => {
    Configs.darkMode = darkMode;
    Colors.change();
    ThemeProvider.instance?.setState({ darkMode });
    Logger.log('Dark mode is', darkMode);
  },
  updateStatusBarHeight: (statusBarHeight = 0) => {
    ThemeProvider.instance?.setState({ statusBarHeight });
  },
  updateBottomSpace: (bottomSpace = 0) => {
    ThemeProvider.instance?.setState({ bottomSpace });
  }
};
